// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3EKE_","insightsList":"newBusinessInsightsMenu_insightsList__3tCAO","active":"newBusinessInsightsMenu_active__1Ei18"};